import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchInventoryItems } from '@/renderer/services/inventoryItemService';
import type { InventoryItemFilterParams } from '@/renderer/types/inventory';

export function useInventoryItems(params: InventoryItemFilterParams) {
  return useQuery({
    queryKey: queryKeys.inventory.itemsList(params),
    queryFn: async () => {
      const result = await fetchInventoryItems(params);
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Failed to fetch inventory items');
      }

      return result.data;
    },
    enabled: !!params.companyId,
    placeholderData: keepPreviousData,
  });
}
